import { Dialog } from '@mui/material'
import { DropPaper } from '../DropPaper'
import MainButton from '../../common/util/input/MainButton'

export const DeleteAttributeDialog = ({
    attributes,
    setAttributes,
    blockRules,
    setBlockRules,
    attributeToDelete,
    setAttributeToDelete,
}) => {
    const close = () => {
        setAttributeToDelete(null)
    }

    const deleteAttribute = () => {
        const tempAttributes = [...attributes]
        const tempBlockRules = [...blockRules]
        for (let i = 0; i < tempAttributes.length; i++) {
            if (tempAttributes[i].attribute_name === attributeToDelete) {
                tempAttributes.splice(i, 1)
            }
        }

        // Find the base block rule, if it exists
        const baseBlockRuleIndex = tempBlockRules.findIndex((element) => {
            return element.base_attribute.attribute_name === attributeToDelete
        })
        if (baseBlockRuleIndex !== -1) {
            tempBlockRules.splice(baseBlockRuleIndex, 1)
        }

        // Delete all other occurences of this attribute in attribute_blacklists
        for (const rule of tempBlockRules) {
            const attributeBlacklistIndex = rule.attribute_blacklist.findIndex(
                (element) => {
                    return element.attribute_name === attributeToDelete
                },
            )
            if (attributeBlacklistIndex !== -1) {
                rule.attribute_blacklist.splice(attributeBlacklistIndex, 1)
            }
        }

        setAttributes(tempAttributes)
        setBlockRules(tempBlockRules)
    }

    return (
        <Dialog
            open={attributeToDelete !== null}
            onClose={() => close()}
            maxWidth="sm"
            fullWidth
        >
            <DropPaper noMargin>
                <div className="text-2xl text-center mb-10">
                    Delete Attribute{' '}
                    <span className="text-primary font-bold">
                        {attributeToDelete}
                    </span>
                    ?
                </div>
                <div className="mb-5">
                    Are you sure you want to delete the attribute{' '}
                    <span className="font-bold text-primary">
                        {attributeToDelete}
                    </span>
                    ?{' '}
                    <b>
                        {
                            attributes.find(
                                (element) =>
                                    element.attribute_name ===
                                    attributeToDelete,
                            )?.possible_values.length
                        }{' '}
                        value(s) will be lost!
                    </b>
                </div>
                <div className="flex flex-wrap justify-center">
                    <div classname="md:w-full w-32 mb-5">
                        <MainButton
                            color="warning"
                            className=""
                            onClick={() => {
                                deleteAttribute()
                                close()
                            }}
                        >
                            {' '}
                            Yes, Delete
                        </MainButton>
                    </div>
                    <div className="md:max-w-60 w-32 mx-2 ">
                        <MainButton
                            color="danger"
                            fullWidth
                            className=""
                            onClick={() => close()}
                        >
                            {' '}
                            No, Cancel
                        </MainButton>
                    </div>
                </div>
            </DropPaper>
        </Dialog>
    )
}
